export function decode(str) {
  try { return atob(str); } catch { return ''; }
}



export function unreverse(str) {
  return str.split('').reverse().join('');
}


export function miroLoader() {
  // Create loader bar if not present
  let loader = document.getElementById('miro-loader');
  if (!loader) {
    loader = document.createElement('div');
    loader.id = 'miro-loader';
    loader.className = 'miro-loader';
    loader.innerHTML = `
      <div class="miro-loader__bar"></div>
      <div class="miro-loader__text">Loading...</div>
    `;
    document.body.appendChild(loader);
  }

  // Show loader
  loader.classList.add('is-active');
  loader.style.opacity = '1';

  // Helper to update progress (0-100)
  function setProgress(percent) {
    const bar = loader.querySelector('.miro-loader__bar');
    if (bar) bar.style.width = `${percent}%`;
    const text = loader.querySelector('.miro-loader__text');
    if (text) text.textContent = `Loading... ${percent}%`;
  }

  // Helper to hide loader
  function hideLoader() {
    loader.classList.remove('is-active');
    loader.style.opacity = '0';
    setTimeout(() => {
      if (loader.parentNode) loader.parentNode.removeChild(loader);
    }, 600);
  }

  // Return API for integration
  return {
    setProgress,
    hideLoader,
    loader
  };
}

export async function fetchAllFrames(boardId, token) {
  let frames = [];
  let cursor = null;
  do {
    const url = new URL(`https://api.miro.com/v2/boards/${boardId}/items`);
    url.searchParams.set('type', 'frame');
    if (cursor) url.searchParams.set('cursor', cursor);
    const res = await fetch(url.toString(), {
      headers: { Authorization: `Bearer ${token}` }
    });
    if (!res.ok) {
      console.error('Error fetching frames:', res.status, await res.text());
      break;
    }
    const data = await res.json();
    frames.push(...data.data);
    cursor = data.cursor;
  } while (cursor);
  return frames;
}

export async function fetchItemsInFrame(boardId, token, frameId) {
  let items = [];
  let cursor = null;
  do {
    const url = new URL(`https://api.miro.com/v2/boards/${boardId}/items`);
    url.searchParams.set('parent_item_id', frameId);
    url.searchParams.set('limit', 50);
    if (cursor) url.searchParams.set('cursor', cursor);
    const res = await fetch(url.toString(), {
      headers: { Authorization: `Bearer ${token}` }
    });
    if (!res.ok) {
      console.error(`Error fetching items for frame ${frameId}:`, res.status, await res.text());
      break;
    }
    const data = await res.json();
    items.push(...data.data);
    cursor = data.cursor;
  } while (cursor);
  return items;
}

export async function fetchAndDisplayImage(item, token) {
  if (!item.data?.imageUrl) return null;
  try {
    const imageUrl = new URL(item.data.imageUrl);
    imageUrl.searchParams.set('format', 'original');
    const res = await fetch(imageUrl.toString(), {
      headers: { Authorization: `Bearer ${token}` }
    });
    if (!res.ok) return null;
    const json = await res.json();
    const signedUrl = json.url;
    if (!signedUrl) return null;
    const img = document.createElement('img');
    img.src = signedUrl;
    return img;
  } catch (err) {
    console.error('Image fetch error:', err);
    return null;
  }
}

// FIXED: Only pass frameId to the callback, let the caller handle boardId/token
export async function getTextFromFrame(frames, frameTitle, fetchItemsInFrameFn) {
  const frame = frames.find(f => (f.data?.title || '').toLowerCase() === frameTitle.toLowerCase());
  if (!frame) return '';
  const items = await fetchItemsInFrameFn(frame.id);
  const textItem = items.find(item => item.type === 'text');
  return textItem?.data?.content || textItem?.data?.text || '';
}

// Utility: sort items by numeric prefix
export function sortItemsByPrefix(items) {
  items.sort((a, b) => {
    const getPrefix = item => {
      const title = item.data?.title || item.title || '';
      const match = title.match(/^(\d+)_/);
      return match ? parseInt(match[1], 10) : 9999;
    };
    return getPrefix(a) - getPrefix(b);
  });
  return items;
}